import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IPortfolioOverviewDisplayed } from 'src/models/products.model';

@Component({
  selector: 'liberro-investment-select-dropdown',
  standalone: false,
  templateUrl: './liberro-investment-select-dropdown.component.html',
  styleUrl: './liberro-investment-select-dropdown.component.less',
})
export class LiberroInvestmentSelectDropdownComponent implements OnChanges {
  @Input() public investments: IPortfolioOverviewDisplayed[] = [];
  @Input() public loading = false;
  @Input() public hasMore = false;
  @Input() public selectedId: null | number = null;
  @Input() public variant: 'dropdown' | 'sheet' = 'dropdown';
  @Output() public portfolioSelected = new EventEmitter<number>();
  @Output() public loadMore = new EventEmitter<void>();

  private loadMoreLocked = false;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading'] && !this.loading) {
      this.loadMoreLocked = false;
    }
  }

  public onPortfolioSelected(portfolioId: number): void {
    if (portfolioId === this.selectedId) return;
    this.portfolioSelected.emit(portfolioId);
  }

  public onScroll(event: Event): void {
    if (this.variant === 'sheet' || this.loading || !this.hasMore || this.loadMoreLocked) {
      return;
    }

    const element = event.target as HTMLElement;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 20) {
      this.loadMoreLocked = true;
      this.loadMore.emit();
    }
  }
}
